import {createContext, useContext, useState} from "react";

const AIContext = createContext();

export const AIProvider = ({ children }) => {
    const [messages, setMessages] = useState([

    ]);

    function addMessage(newMessage) {

        if(newMessage.hasOwnProperty("type") && newMessage.hasOwnProperty("content")) {
            setMessages([...messages, newMessage]);
        }
    }

    return (
        <AIContext.Provider value={{addMessage, messages}}>
            {children}
        </AIContext.Provider>
    );
};

export const useAI = () => useContext(AIContext);